export const brandingCs = {
  'branding.title': 'Vzhled organizace',
  'branding.intro': 'Vytvořte vlastní vizuální identitu pro všechny role organizace. Šablona určuje fonty, navigaci, plochy a komponenty. Uložení návrhu a použití vzhledu jsou dva oddělené kroky.',
  'branding.template': 'Šablona',
  'branding.template.studio': 'Studio — výrazná identita a přehledné akce',
  'branding.template.standard': 'Standard — neutrální přehled',
  'branding.template.editorial': 'Editorial — redakční styl a důraz na program',
  'branding.template.focus': 'Focus — soustředěný pracovní prostor',
  'branding.templateHelp': 'Studio, Editorial a Focus mají vlastní typografii a kompozici. Standard zachovává střídmý vzhled. Výběr nemění oprávnění ani obsah akcí; aktivovaný vzhled převezmou všechny role organizace.',
  'branding.typography.studio': 'Manrope · výrazná typografie a tmavá navigace',
  'branding.typography.editorial': 'DM Serif Display + Manrope · teplé plochy a redakční rytmus',
  'branding.typography.focus': 'Manrope · čisté plochy a kompaktní navigace',
  'branding.typography.standard': 'Inter · neutrální pracovní rozhraní',
  'branding.palette': 'Barevná paleta',
  'branding.palette.violet': 'Fialová',
  'branding.palette.ocean': 'Oceán',
  'branding.palette.forest': 'Les',
  'branding.palette.terracotta': 'Terakota',
  'branding.paletteHelp': 'Palety mají pevně navržené barvy. Nezadáváte vlastní CSS ani HTML.',
  'branding.displayName': 'Zobrazovaný název organizace',
  'branding.tagline.cs': 'Krátké představení — čeština',
  'branding.tagline.en': 'Krátké představení — angličtina',
  'branding.intro.cs': 'Úvodní text — čeština',
  'branding.intro.en': 'Úvodní text — angličtina',
  'branding.website': 'Web organizace (HTTPS, nepovinné)',
  'branding.contactEmail': 'Kontaktní e-mail (nepovinné)',
  'branding.logo': 'Logo organizace',
  'branding.logoUpload': 'Nahrát logo',
  'branding.logoHelp': 'Výchozí logo VCode můžete nahradit vlastním logem organizace. PNG, JPEG nebo WebP, nejvýše 256 KiB. SVG není podporováno. Vlastní logo se přijme pouze po úspěšné skutečné antivirové kontrole.',
  'branding.logoAlt': 'Popis loga pro čtečky obrazovky',
  'branding.logoRemove': 'Obnovit výchozí logo VCode',
  'branding.logoSaved': 'Logo bylo zkontrolováno a nahráno. Uložte návrh a potom použijte vzhled, aby se zobrazilo celé organizaci.',
  'branding.logoError': 'Logo nebylo přijato. Ověřte soubor a dostupnost antivirové kontroly; neověřený soubor se nepoužije.',
  'branding.logoInvalid': 'Vyberte soubor PNG, JPEG nebo WebP o velikosti 1 až 262 144 bajtů. SVG ani jiné formáty nelze nahrát.',
  'branding.logoPreviewError': 'Náhled loga se nepodařilo načíst. Uložené logo nebylo změněno.',
  'branding.hero': 'Úvodní obrázek',
  'branding.heroUpload': 'Nahrát úvodní obrázek',
  'branding.heroHelp': 'PNG, JPEG nebo WebP, nejvýše 2 MiB a rozměry do 4096 × 4096 px. Obrázek se přijme pouze po úspěšné antivirové kontrole. Bez vlastního obrázku šablona použije výchozí grafiku; Standard obrázek nemá.',
  'branding.heroAlt': 'Popis obrázku (prázdný pro čistě dekorativní grafiku)',
  'branding.heroReset': 'Obnovit výchozí obrázek šablony',
  'branding.heroSaved': 'Obrázek byl zkontrolován a nahrán. Uložte návrh a potom použijte vzhled.',
  'branding.heroError': 'Obrázek nebyl přijat. Ověřte soubor a dostupnost antivirové kontroly; neověřený soubor se nepoužije.',
  'branding.heroInvalid': 'Vyberte PNG, JPEG nebo WebP o velikosti 1 až 2 097 152 bajtů. SVG ani jiné formáty nelze nahrát.',
  'branding.heroPreviewError': 'Vlastní obrázek se nepodařilo načíst. Náhled používá výchozí grafiku šablony; uložený soubor se nezměnil.',
  'branding.heroDefault': 'Výchozí grafika vybrané šablony',
  'branding.heroCustom': 'Vlastní obrázek organizace',
  'branding.preview': 'Náhled vzhledu',
  'branding.previewHelp': 'Náhled používá aktuální zveřejněné akce organizace. Přepnutí zařízení nebo jazyka návrh neukládá ani nezveřejňuje.',
  'branding.previewError': 'Akce pro náhled se nepodařilo načíst. Prázdný náhled není potvrzením, že organizace žádné akce nemá.',
  'branding.preview.desktop': 'Počítač',
  'branding.preview.mobile': 'Mobil',
  'branding.preview.language': 'Jazyk náhledu',
  'branding.preview.area': 'Oblast náhledu',
  'branding.preview.attendee': 'Účastnické stránky',
  'branding.preview.workspace': 'Pracovní rozhraní',
  'branding.settings': 'Identita organizace',
  'branding.save': 'Uložit návrh',
  'branding.apply': 'Použít uložený vzhled',
  'branding.applyConfirm': 'Potvrzuji použití uloženého návrhu pro všechny role této organizace.',
  'branding.saved': 'Návrh byl uložen. Aktivní vzhled organizace se nezměnil.',
  'branding.applied': 'Uložený vzhled byl použit pro všechny role organizace.',
  'branding.active': 'Aktivní vzhled',
  'branding.draft': 'Uložený návrh',
  'branding.unsaved': 'Rozepsané změny',
  'branding.noActive': 'Dosud nebyl použit vlastní vzhled; aplikace používá výchozí zobrazení.',
  'branding.noDraft': 'Návrh zatím není uložen.',
  'branding.applyHelp': 'Použití je možné pouze pro uložený návrh bez rozepsaných změn nebo čekajících souborů. Vzhled se použije pro účastníky, správce, organizátory i ostatní role této organizace. Tímto krokem se nemění přihlašovací stránka Keycloaku ani jiné organizace.',
  'branding.error': 'Akci se nepodařilo dokončit. Před opakováním načtěte aktuální stav a ověřte výsledek.',
  'branding.stale': 'Vzhled mezitím změnil jiný správce. Vaše změny zůstaly zachované a nelze je automaticky přepsat. Načtěte aktuální stav k porovnání.',
  'branding.comparison': 'Aktuální uložený návrh je načtený. Porovnejte jeho souhrn se svými rozepsanými změnami a výslovně zvolte další postup.',
  'branding.continueDraft': 'Porovnal/a jsem změny, pokračovat se svým návrhem',
  'branding.useStored': 'Použít aktuální uložený návrh',
  'branding.reload': 'Načíst aktuální stav',
  'branding.invalid': 'Zkontrolujte název, délku textů, HTTPS adresu, e-mail a popis nahraného loga.',
  'branding.version': 'Verze {version}',
};

export const brandingEn: Record<keyof typeof brandingCs, string> = {
  'branding.title': 'Organization appearance',
  'branding.intro': 'Build a visual identity for every role in your organization. Templates define fonts, navigation, surfaces and components. Saving a draft and applying the appearance are separate steps.',
  'branding.template': 'Template',
  'branding.template.studio': 'Studio — distinctive identity and clear events',
  'branding.template.standard': 'Standard — neutral overview',
  'branding.template.editorial': 'Editorial — editorial style with a focus on the programme',
  'branding.template.focus': 'Focus — a focused workspace',
  'branding.templateHelp': 'Studio, Editorial and Focus have distinct typography and composition. Standard retains a restrained appearance. Your choice does not change permissions or event content; the applied identity is shared by all organization roles.',
  'branding.typography.studio': 'Manrope · bold typography and dark navigation',
  'branding.typography.editorial': 'DM Serif Display + Manrope · warm surfaces and editorial rhythm',
  'branding.typography.focus': 'Manrope · clean surfaces and compact navigation',
  'branding.typography.standard': 'Inter · a neutral working interface',
  'branding.palette': 'Color palette',
  'branding.palette.violet': 'Violet',
  'branding.palette.ocean': 'Ocean',
  'branding.palette.forest': 'Forest',
  'branding.palette.terracotta': 'Terracotta',
  'branding.paletteHelp': 'Palettes use curated colors. No custom CSS or HTML is accepted.',
  'branding.displayName': 'Organization display name',
  'branding.tagline.cs': 'Short introduction — Czech',
  'branding.tagline.en': 'Short introduction — English',
  'branding.intro.cs': 'Introduction — Czech',
  'branding.intro.en': 'Introduction — English',
  'branding.website': 'Organization website (HTTPS, optional)',
  'branding.contactEmail': 'Contact email (optional)',
  'branding.logo': 'Organization logo',
  'branding.logoUpload': 'Upload logo',
  'branding.logoHelp': 'Replace the default VCode logo with your organization’s own logo. PNG, JPEG or WebP, up to 256 KiB. SVG is not supported. Custom logos are accepted only after a successful real antivirus scan.',
  'branding.logoAlt': 'Logo description for screen readers',
  'branding.logoRemove': 'Restore default VCode logo',
  'branding.logoSaved': 'The logo was scanned and uploaded. Save the draft and then apply the appearance to show it throughout the organization.',
  'branding.logoError': 'The logo was not accepted. Check the file and antivirus availability; unverified files are not used.',
  'branding.logoInvalid': 'Choose a PNG, JPEG or WebP file between 1 and 262,144 bytes. SVG and other formats cannot be uploaded.',
  'branding.logoPreviewError': 'The logo preview could not be loaded. The stored logo was not changed.',
  'branding.hero': 'Introductory image',
  'branding.heroUpload': 'Upload introductory image',
  'branding.heroHelp': 'PNG, JPEG or WebP, up to 2 MiB and 4096 × 4096 px. Images are accepted only after a successful antivirus scan. Without an override, the template uses its bundled artwork; Standard has no image.',
  'branding.heroAlt': 'Image description (leave empty for decorative artwork)',
  'branding.heroReset': 'Restore template default image',
  'branding.heroSaved': 'The image was scanned and uploaded. Save the draft and then apply the appearance.',
  'branding.heroError': 'The image was not accepted. Check the file and antivirus availability; unverified files are not used.',
  'branding.heroInvalid': 'Choose a PNG, JPEG or WebP file between 1 and 2,097,152 bytes. SVG and other formats cannot be uploaded.',
  'branding.heroPreviewError': 'The custom image could not be loaded. The preview uses bundled template artwork; the stored file was not changed.',
  'branding.heroDefault': 'Selected template’s bundled artwork',
  'branding.heroCustom': 'Custom organization image',
  'branding.preview': 'Appearance preview',
  'branding.previewHelp': 'The preview uses the organization’s current published events. Changing device or language does not save or publish the draft.',
  'branding.previewError': 'Events could not be loaded for the preview. An empty preview does not confirm that the organization has no events.',
  'branding.preview.desktop': 'Desktop',
  'branding.preview.mobile': 'Mobile',
  'branding.preview.language': 'Preview language',
  'branding.preview.area': 'Preview area',
  'branding.preview.attendee': 'Attendee pages',
  'branding.preview.workspace': 'Working interface',
  'branding.settings': 'Organization identity',
  'branding.save': 'Save draft',
  'branding.apply': 'Apply saved appearance',
  'branding.applyConfirm': 'I confirm applying the saved draft for all roles in this organization.',
  'branding.saved': 'The draft was saved. The active organization appearance has not changed.',
  'branding.applied': 'The saved appearance was applied for all organization roles.',
  'branding.active': 'Active appearance',
  'branding.draft': 'Saved draft',
  'branding.unsaved': 'Unsaved changes',
  'branding.noActive': 'No custom appearance has been applied; the application uses its default view.',
  'branding.noDraft': 'No draft has been saved yet.',
  'branding.applyHelp': 'Only a saved draft without unsaved changes or pending files can be applied. The identity is shared by attendees, administrators, organizers and other roles in this organization. This does not change the Keycloak sign-in page or any other organization.',
  'branding.error': 'The action could not be completed. Reload the current state and check the result before trying again.',
  'branding.stale': 'Another administrator has changed the appearance. Your input was preserved and cannot be overwritten automatically. Reload the current state for comparison.',
  'branding.comparison': 'The current saved draft has been loaded. Compare its summary with your unsaved changes and explicitly choose how to continue.',
  'branding.continueDraft': 'I compared the changes; continue with my draft',
  'branding.useStored': 'Use the current saved draft',
  'branding.reload': 'Reload current state',
  'branding.invalid': 'Check the name, text lengths, HTTPS address, email and uploaded logo description.',
  'branding.version': 'Version {version}',
};
